import { lazy } from 'react'

const Taiji = lazy(() => import('@/pages/Taiji'))

const taijiRoute = {
  path: 'taiji',
  element: <Taiji />,
  meta: { title: '太极图', icon: 'ThunderboltOutlined', permission: 'taiji:view' },
}

export default taijiRoute
